var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('daily-scrum',{attrs:{"dailyScrum":_vm.dailyScrum,"loggedInEmployee":_vm.loggedInEmployee,"isSubmitting":false},on:{"save":_vm.onSave,"cancel":_vm.onCancel}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }